import React, { useState } from "react";

export const Offline = React.createContext(null);
export const OfflineContext = props => {
    const [offline, setOffline] = useState("0");
    const [intervalId, setIntervalId] = useState();

    const checkOffline = () => {
        if (intervalId !== undefined) {
            clearInterval(intervalId);
        }

        let id = setInterval(() => {
            setOffline(sessionStorage.getItem("isOffline"));
        }, 5000);
        setIntervalId(id);
    };
    
    return (
        <>
            <Offline.Provider value={{ intervalId, offline, checkOffline }}>
                {props.children}
            </Offline.Provider>
        </>
    );
}
